import {
  getHabitInterventionBasic,
  getHabitInterventionsByUserAndDate,
  getAllHabitInterventionsByUserId,
  upsertHabitIntervention,
} from '../util/api';

export const FETCH_HABIT_INTERVENTION_BASIC_REQUEST = 'app/habit_intervention_basic/FETCH_HABIT_INTERVENTION_BASIC_REQUEST';
export const FETCH_HABIT_INTERVENTION_BASIC_SUCCESS = 'app/habit_intervention_basic/FETCH_HABIT_INTERVENTION_BASIC_SUCCESS';
export const FETCH_HABIT_INTERVENTION_BASIC_ERROR = 'app/habit_intervention_basic/FETCH_HABIT_INTERVENTION_BASIC_ERROR';

export const FETCH_HABIT_INTERVENTION_USER_RECORDS_REQUEST =
  'app/habit_intervention_basic/FETCH_HABIT_INTERVENTION_USER_RECORDS_REQUEST';
export const FETCH_HABIT_INTERVENTION_USER_RECORDS_SUCCESS =
  'app/habit_intervention_basic/FETCH_HABIT_INTERVENTION_USER_RECORDS_SUCCESS';
export const FETCH_HABIT_INTERVENTION_USER_RECORDS_ERROR =
  'app/habit_intervention_basic/FETCH_HABIT_INTERVENTION_USER_RECORDS_ERROR';

export const FETCH_ALL_HABIT_INTERVENTION_RECORDS_REQUEST =
  'app/habit_intervention_basic/FETCH_ALL_HABIT_INTERVENTION_RECORDS_REQUEST';
export const FETCH_ALL_HABIT_INTERVENTION_RECORDS_SUCCESS =
  'app/habit_intervention_basic/FETCH_ALL_HABIT_INTERVENTION_RECORDS_SUCCESS';
export const FETCH_ALL_HABIT_INTERVENTION_RECORDS_ERROR =
  'app/habit_intervention_basic/FETCH_ALL_HABIT_INTERVENTION_RECORDS_ERROR';

export const initialState = {
  habitInterventions: [],
  habitInterventionUserRecords: [],
  allHabitInterventionRecords: [],
  isFetching: false,
  isFetchingUserRecords: false,
  isFetchingAllHabitInterventionRecords: false,
  fetchError: null,
  userRecordsError: null,
  fetchAllHabitInterventionRecordsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_HABIT_INTERVENTION_BASIC_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_HABIT_INTERVENTION_BASIC_SUCCESS:
      return { ...state, isFetching: false, habitInterventions: payload, fetchError: null };
    case FETCH_HABIT_INTERVENTION_BASIC_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    case FETCH_HABIT_INTERVENTION_USER_RECORDS_REQUEST:
      return { ...state, isFetchingUserRecords: true, userRecordsError: null };
    case FETCH_HABIT_INTERVENTION_USER_RECORDS_SUCCESS:
      return { ...state, isFetchingUserRecords: false, habitInterventionUserRecords: payload, userRecordsError: null };
    case FETCH_HABIT_INTERVENTION_USER_RECORDS_ERROR:
      return { ...state, isFetchingUserRecords: false, userRecordsError: payload };
    case FETCH_ALL_HABIT_INTERVENTION_RECORDS_REQUEST:
      return { ...state, isFetchingAllHabitInterventionRecords: true, fetchAllHabitInterventionRecordsError: null };
    case FETCH_ALL_HABIT_INTERVENTION_RECORDS_SUCCESS:
      return {
        ...state,
        isFetchingAllHabitInterventionRecords: false,
        allHabitInterventionRecords: payload,
        fetchAllHabitInterventionRecordsError: null,
      };
    case FETCH_ALL_HABIT_INTERVENTION_RECORDS_ERROR:
      return {
        ...state,
        isFetchingAllHabitInterventionRecords: false,
        fetchAllHabitInterventionRecordsError: payload,
      };
    default:
      return state;
  }
}

export const fetchHabitInterventionBasicRequest = () => ({ type: FETCH_HABIT_INTERVENTION_BASIC_REQUEST });
export const fetchHabitInterventionBasicSuccess = habitInterventions => ({
  type: FETCH_HABIT_INTERVENTION_BASIC_SUCCESS,
  payload: habitInterventions,
});
export const fetchHabitInterventionBasicError = error => ({ type: FETCH_HABIT_INTERVENTION_BASIC_ERROR, payload: error });

export const fetchHabitInterventionUserRecordsRequest = () => ({
  type: FETCH_HABIT_INTERVENTION_USER_RECORDS_REQUEST,
});
export const fetchHabitInterventionUserRecordsSuccess = records => ({
  type: FETCH_HABIT_INTERVENTION_USER_RECORDS_SUCCESS,
  payload: records,
});
export const fetchHabitInterventionUserRecordsError = error => ({
  type: FETCH_HABIT_INTERVENTION_USER_RECORDS_ERROR,
  payload: error,
});

export const fetchAllHabitInterventionRecordsRequest = () => ({
  type: FETCH_ALL_HABIT_INTERVENTION_RECORDS_REQUEST,
});
export const fetchAllHabitInterventionRecordsSuccess = records => ({
  type: FETCH_ALL_HABIT_INTERVENTION_RECORDS_SUCCESS,
  payload: records,
});
export const fetchAllHabitInterventionRecordsError = error => ({
  type: FETCH_ALL_HABIT_INTERVENTION_RECORDS_ERROR,
  payload: error,
});

export const fetchHabitInterventionBasicData = state => {
  const s = state.habitInterventionBasic || {};
  return {
    habitInterventions: s.habitInterventions || [],
    habitInterventionUserRecords: s.habitInterventionUserRecords || [],
    allHabitInterventionRecords: s.allHabitInterventionRecords || [],
    isFetching: s.isFetching || false,
    isFetchingUserRecords: s.isFetchingUserRecords || false,
    isFetchingAllHabitInterventionRecords: s.isFetchingAllHabitInterventionRecords || false,
    fetchError: s.fetchError || null,
    userRecordsError: s.userRecordsError || null,
    fetchAllHabitInterventionRecordsError: s.fetchAllHabitInterventionRecordsError || null,
  };
};

export const fetchHabitInterventionBasic = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchHabitInterventionBasicRequest());
  try {
    const result = await getHabitInterventionBasic(params);
    dispatch(fetchHabitInterventionBasicSuccess(result.habitInterventions || []));
    return result;
  } catch (error) {
    console.error('Error fetching habit intervention basic:', error);
    dispatch(fetchHabitInterventionBasicError(error.message || 'Failed to fetch habit intervention basic'));
    throw error;
  }
};

export const fetchHabitInterventionUserRecords = ({ userId, date }) => async (dispatch, getState, sdk) => {
  if (!userId || !date) {
    dispatch(fetchHabitInterventionUserRecordsSuccess([]));
    return { records: [] };
  }

  dispatch(fetchHabitInterventionUserRecordsRequest());
  try {
    const result = await getHabitInterventionsByUserAndDate({ userId, date });
    const records = result.records || [];
    dispatch(fetchHabitInterventionUserRecordsSuccess(records));
    return result;
  } catch (error) {
    console.error('Error fetching habit intervention user records:', error);
    dispatch(fetchHabitInterventionUserRecordsError(error.message || 'Failed to fetch records'));
    throw error;
  }
};

export const fetchAllHabitInterventionRecords = ({ userId }) => async (dispatch, getState, sdk) => {
  if (!userId) {
    dispatch(fetchAllHabitInterventionRecordsSuccess([]));
    return { records: [] };
  }
  dispatch(fetchAllHabitInterventionRecordsRequest());
  try {
    const result = await getAllHabitInterventionsByUserId({ userId });
    const records = result.records || [];
    dispatch(fetchAllHabitInterventionRecordsSuccess(records));
    return result;
  } catch (error) {
    console.error('Error fetching all habit intervention records:', error);
    dispatch(fetchAllHabitInterventionRecordsError(error.message || 'Failed to fetch all records'));
    throw error;
  }
};

export const saveHabitInterventionResponse = body => async (dispatch, getState, sdk) => {
  await upsertHabitIntervention(body);
  await dispatch(
    fetchHabitInterventionUserRecords({
      userId: body.userId,
      date: body.date,
    })
  );
  await dispatch(fetchAllHabitInterventionRecords({ userId: body.userId }));
};
